<div
  class="bw-pill-legacy"
  [style.background-color]="pillConfig.backgroundColor ?? 'var(--blue-10)'"
  [ngClass]="{ 'icon-left': pillConfig.iconLeftName, 'icon-right': pillConfig.iconRightName }"
>
  <div class="flex-row">
    <bw-icon-legacy
      *ngIf="pillConfig.iconLeftName"
      [size]="pillConfig.iconLeftSize || 20"
      [iconName]="pillConfig.iconLeftName"
      [color]="pillConfig.iconLeftColor"
      [ngClass]="{ 'pr-xs': pillConfig.iconLeftPadding }"
    >
    </bw-icon-legacy>
    <ng-container [ngSwitch]="pillConfig.labelStyle">
      <typography-legacy *ngSwitchCase="'bold'" text-small-semibold [color]="pillConfig.labelColor">{{ pillConfig.label }}</typography-legacy>
      <typography-legacy *ngSwitchDefault text-small-regular [color]="pillConfig.labelColor">{{ pillConfig.label }}</typography-legacy>
    </ng-container>
    <bw-icon-legacy *ngIf="pillConfig.iconRightName" size="20" [iconName]="pillConfig.iconRightName" [color]="pillConfig.iconRightColor">
    </bw-icon-legacy>
  </div>
</div>
